import "./Contact.css";

const Contact = () => {
  return (
    <div id="contact" className="app__contact">
      <div className="app__contact-wrapper">
        <div className="app__contact-info">
          Eiscafé Bellini<br />
          Familie Vitanza<br />
          Frantzplatz<br />
          67487 Maikammer<br /> <br />
          <a href={"tel:063216790131"}>Telefon: 06321 6790131</a>
        </div>
        <a className="app__contact-mapWrapper" href="https://www.google.com/maps/dir//bellini+maikammer/@49.1548659,8.1153488,11z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47964f4213e12d39:0xae6db5792013dd7f!2m2!1d8.133128!2d49.3041228">
          <img className="app__contact-map" src={require("../../assets/Map.png")} alt="Karte" />
        </a>
      </div>
    </div>
  );
};

export default Contact;
